var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.products?.length)?_c('slider',{staticClass:"products-carousel"},_vm._l((_vm.products),function(product,i){return _c('slideritem',{key:i},[_c('ProductCard',{attrs:{"product":product}})],1)}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }